interface ScoreGrade {
  score: number;
  grade: number;
}

interface ExportSettings {
  passingGrade: string;
  maxScore: number;
  term: string;
  linearPercentage: string;
  pointsType: string;
}

function formatPointsType(pointsType: string): string {
  const labels: Record<string, string> = {
    full: "Hele punten",
    half: "Halve punten",
    quarter: "Kwart punten",
    tenth: "Tiende punten",
  };
  return labels[pointsType] || pointsType;
}

function formatNTerm(term: string): string {
  return (Number(term) / 100).toFixed(1);
}

export function exportAsCSV(
  scores: ScoreGrade[],
  settings: ExportSettings,
): void {
  const BOM = "\uFEFF"; // UTF-8 BOM for Excel compatibility

  // Header with settings info
  const header = [
    `# Cijfertabel - Berekencijfers.nl`,
    `# Maximale score: ${settings.maxScore}`,
    `# Voldoende: ${settings.passingGrade}`,
    `# N-Term: ${formatNTerm(settings.term)}`,
    `# Lineair percentage: ${settings.linearPercentage}%`,
    `# Type punten: ${formatPointsType(settings.pointsType)}`,
    `#`,
    `Juist;Onjuist;Cijfer`,
  ].join("\n");

  // Data rows (reversed to show highest score first)
  const rows = [...scores]
    .reverse()
    .map((s) => {
      const juist = s.score;
      const onjuist = settings.maxScore - s.score;
      const cijfer = s.grade.toFixed(1);
      return `${juist};${onjuist};${cijfer}`;
    })
    .join("\n");

  const csvContent = BOM + header + "\n" + rows;

  // Create and trigger download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  const filename = `cijfertabel-${settings.maxScore}pt-${formatNTerm(settings.term)}nterm.csv`;

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function copyTableToClipboard(
  scores: ScoreGrade[],
  maxScore: number,
): Promise<boolean> {
  // Tab-separated for easy paste into Excel/Sheets
  const header = "Juist\tOnjuist\tCijfer";
  const rows = [...scores]
    .reverse()
    .map((s) => {
      const juist = s.score;
      const onjuist = maxScore - s.score;
      const cijfer = s.grade.toFixed(1);
      return `${juist}\t${onjuist}\t${cijfer}`;
    })
    .join("\n");

  const content = header + "\n" + rows;

  return navigator.clipboard
    .writeText(content)
    .then(() => true)
    .catch(() => false);
}
